module.exports = __webpack_public_path__ + "static/timeline1993-3-2b0c8da0a5a5d71a5e1f002b48d857e1.jpeg";